import styled from 'styled-components';
import Grid from 'ui/atoms/grid';

export const OpenInvestmentsGrid = styled(Grid)`
  align-items: center;
`;
